import { SocketConstants } from "../config/SocketConstants";
import SocketService from "../services/SocketService";
import io, { Socket } from "socket.io-client";

const socketService = new SocketService();

export class UserInfoMapperSocketHandler {
  private SERVER_URL: string = SocketConstants.SOCKET_CHAT_URL;
  public socketObj: any;

  initSocket = (room: string, onMessageCallBack: Function) => {
    const socketOptions = {
      query: { room: room },
      secure: true,
    };
    this.socketObj = io(SocketConstants.SOCKET_CHAT_URL, socketOptions);

    this.socketObj.on("connect", () => {
      console.log(`Socket connected for room: ${room}`);
    });

    this.socketObj.on("disconnect", () => {
      console.log(`Socket disconnected for room: ${room}`);
    });

    if (room) {
      this.socketObj.on("message", (msg: any) => {
        onMessageCallBack(msg);
      });
    }
  };

  // initSocket = (room: string, onMessageCallBack: Function) => {
  //   // let roomString = `room=${room}`;
  //   const socketOptions = {
  //     query: { room: room },
  //     secure: true, // Set secure option to true
  //   };
  //   this.socketObj = io(SocketConstants.SOCKET_CHAT_URL, socketOptions);

  //   if (room) {
  //     // Connect to room once
  //     this.socketObj.on("message", (msg: any) => {
  //       onMessageCallBack(msg);
  //     });
  //   }
  // };

  sendMessage = async (message: any) => {
    const data = JSON.parse(message);
    data["timestamp"] = new Date().getMilliseconds();
    console.log("Sending message now", data);

    const socketEventVo = {
      eventType: data?.sub_type || data?.type,
      message: JSON.stringify(data),
      sessionId: data?.room_id,
      source: "trainee_system",
      timestamp: Date.now().toString(),
    };

    try {
      const response:any = await socketService.logSocketEvent(socketEventVo);
      const responseData = await response.json();
      console.log(responseData);
    } catch (err) {
      console.log("Error while capturing event details");
    }

    this.socketObj?.emit("message", message);
  };

  // setMessageHandler = (newOnMessageCallBack: Function) => {
  //   this.socketObj.on("message", (msg: any) => {
  //     console.log(
  //       "🚀 ~ UserInfoMapperSocketHandler ~ this.socketObj.on ~ msg:",
  //       msg
  //     );

  //     newOnMessageCallBack(msg);
  //   });
  // };

  setMessageHandler = (newOnMessageCallBack: Function) => {
    if (this.socketObj) {
      this.socketObj.on("message", (msg: any) => {
        newOnMessageCallBack(msg);
      });
    }
  };

  disconnect = () => {
    if (this.socketObj) {
      this.socketObj.off("message");
      this.socketObj.disconnect();
      this.socketObj = null;
    }
  };
}
